var _style, _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneCallDark = function SvgPhoneCallDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "phone-call-dark-Layer_1",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".phone-call-dark-st3{fill:#00c7be}")), /*#__PURE__*/React.createElement("g", {
    id: "phone-call-dark-_x28_DEV_x29_-Assets"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-call-dark-icon-dark-call"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "phone-call-dark-Adobe_OpacityMaskFilter",
    width: 52,
    height: 52,
    x: 6,
    y: 6,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "phone-call-dark-mask-2_00000134929308046928387910000012999661962089029275_",
    width: 52,
    height: 52,
    x: 6,
    y: 6,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#phone-call-dark-Adobe_OpacityMaskFilter)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "phone-call-dark-path-1_00000146501041295702975630000005272233697821223082_",
    d: "M0 0h64v64H0z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "phone-call-dark-icon-call",
    style: {
      mask: "url(#phone-call-dark-mask-2_00000134929308046928387910000012999661962089029275_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 31.9c-.6 0-1-.4-1-1C56 18.3 45.7 8 33.1 8c-.6 0-1-.4-1-1s.4-1 1-1C46.8 6 58 17.2 58 30.9c0 .6-.4 1-1 1",
    className: "phone-call-dark-st3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 31.9c-.6 0-1-.4-1-1 0-9-7.4-16.4-16.4-16.4-.6 0-1-.4-1-1s.4-1 1-1c10.1 0 18.4 8.2 18.4 18.4 0 .6-.5 1-1 1",
    className: "phone-call-dark-st3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 31.9c-.6 0-1-.4-1-1 0-5.4-4.4-9.9-9.9-9.9-.6 0-1-.4-1-1s.4-1 1-1C39.6 19 45 24.4 45 30.9c0 .6-.5 1-1 1",
    className: "phone-call-dark-st3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.4 51c-2 0-4.3-.4-6.7-1.1-6-1.9-12.4-6-17.9-11.6C-.1 26.4-4.5 12.1 1.9 5.8 3.2 4.5 5.4 2.9 7 1.7c.7-.5 1.7-.7 2.6-.5s1.7.7 2.2 1.5l6.9 11c.5.8.6 1.7.4 2.5q-.3 1.35-1.5 2.1l-4.1 2.4q-.45.3-.6.9c-.1.4 0 .7.2 1 1.7 2.3 3.9 4.9 6.6 7.7 2.8 2.8 5.3 5 7.7 6.6.3.2.7.3 1 .2q.6-.15.9-.6l2.4-4.1q.75-1.2 2.1-1.5c.9-.2 1.8-.1 2.5.4l11 6.9c.8.5 1.3 1.3 1.5 2.2s0 1.8-.5 2.6c-1.1 1.6-2.8 3.8-4.1 5.1-1.9 1.9-4.6 2.9-7.8 2.9M8.9 3.2c-.3 0-.5.1-.8.2-1.6 1.1-3.6 2.7-4.8 3.9-5.4 5.4-1 18.7 9.9 29.6 5.4 5.4 11.4 9.3 17.1 11.1 5.5 1.8 9.9 1.3 12.4-1.2.9-.9 2.3-2.6 3.8-4.8.2-.3.3-.7.2-1q-.15-.6-.6-.9l-11-6.9c-.3-.2-.7-.2-1-.2-.3.1-.6.3-.8.6l-2.4 4.1c-.5.8-1.3 1.4-2.2 1.5-.9.2-1.8 0-2.6-.5-2.5-1.7-5.1-4-7.9-6.9-2.9-2.9-5.1-5.5-6.9-7.9-.5-.7-.7-1.7-.5-2.6s.8-1.7 1.5-2.2l4.1-2.4c.3-.2.5-.5.6-.8s0-.7-.2-1L10 3.8q-.3-.45-.9-.6z",
    style: {
      fill: "#00293c"
    },
    transform: "translate(7 7)"
  })))));
};
export default SvgPhoneCallDark;